var portfolioPositionsList = {
	caption: "Portfolio positions",
	name: "Libellé",
	numberOfShares: "Quantité/Nominal",
	isin: "ISIN",
	price: "Dernier prix",
	dateTime: "Heure/Date",
	todayChange: "Chg. aujourd'hui",
	unrealizedPerformance: "Perf. non réalisée",
	marketValue: "Valeur de marché",
	purchaseValue: "Valeur d'achat",
	weight: "Poids %",
	actions: "Actions",
	noPositions: "Aucunes Positions.",
	averagePurchasePrice: "Prix d'achat moyen"
};
var fr = {
	portfolioPositionsList: portfolioPositionsList
};

export { fr as default, portfolioPositionsList };
